import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=5ad06d22&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&id=5ad06d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad06d22",
  null
  
)

export default component.exports